import * as types from '../mutations'
import galleryService from '@/services/gallery'

const state = {
  gallery: []
}

const getters = {
  gallery: (state) => state.gallery
}

const actions = {
  async loadGallery ({ commit }) {
    try {
      const res = await galleryService.loadGallery()

      commit(types.SET_GALLERY, res)
      return Promise.resolve()
    } catch (err) {
      return Promise.reject(err)
    }
  }
}

const mutations = {

  [types.SET_GALLERY] (state, gallery) {
    state.gallery = gallery
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
